import { z } from "zod";
import { EventSchemas } from "../event-registry/schemas";
import { NotificationDtoSchema } from "../notification/schema";

export const InterviewReminderKindSchema = z.enum([
  "response_nudge",
  "day_before",
  "hour_before",
]);

export const InterviewReminderRecipientRoleSchema = z.enum([
  "employee",
  "employer",
]);

export type InterviewReminderKind = z.infer<typeof InterviewReminderKindSchema>;
export type InterviewReminderRecipientRole = z.infer<
  typeof InterviewReminderRecipientRoleSchema
>;

const InterviewReminderEmailEventSchema = z.object({
  id: z.string(),
  name: z.literal("email/interview.reminder"),
  data: EventSchemas["email/interview.reminder"],
});

export const InterviewReminderDispatchPayloadSchema = z.object({
  emailEvents: InterviewReminderEmailEventSchema.array(),
  notifications: NotificationDtoSchema.array(),
});

export type InterviewReminderDispatchPayload = z.infer<
  typeof InterviewReminderDispatchPayloadSchema
>;
